module.exports = __webpack_public_path__ + "img/Res_Mus_ckl.acd2582d.jpg";